import React from 'react';
import { Box, Tag, Text, Title } from '@nimbus-ds/components';
import { useTranslationWithPrefix } from 'commons/utils';

const PersonalDataArgentinaSkeleton = (): JSX.Element => {
  const { t } = useTranslationWithPrefix('configuration.personalData');

  return (
    <Box display="flex" flexDirection="column" gap="4">
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Title as="h4">{t('cardTitle')}</Title>
        <Tag.Skeleton />
      </Box>
      <Box display="flex" flexDirection="column" alignItems="stretch" gap="6">
        <Box display="flex" flexDirection="column" alignItems="stretch" gap="4">
          <Text.Skeleton />
          <Text.Skeleton />
        </Box>
      </Box>
    </Box>
  );
};

export default PersonalDataArgentinaSkeleton;
